<template>
  <v-row no-gutters align="center">
    <v-col cols="2" style="align-self: center" class="mr-4">
      <CleedIcon :icon="notifications.mode_icon" />
    </v-col>
    <v-col cols="10">
      <span>{{ notifications.text }}</span>
      <v-divider dark class="ma-4"></v-divider>
      <span class="caption" v-if="notifications.status">
        Message Status : {{ notifications.status }}
      </span>
    </v-col>
  </v-row>
</template>

<script>
import CleedIcon from "../core/CleedIcon.vue";
export default {
  name: "notif_component",
  components: {
    CleedIcon,
  },
  props: {
    notifications: {
      type: Object,
      default: () => {},
    },
  },
  mounted() {
    console.log(this.notifications);
  },
};
</script>
